import { ReactNode } from 'react'
import styled from 'styled-components'

import { PageBackground } from '@/components/elements/PageBackground'
import { PageTitle } from '@/components/elements/PageTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TopPageTitle } from '@/components/elements/TopPageTitle'
import { BreadCrumbs } from '@/components/enlayouts/BreadCrumbs'
import { FooterArea as Footer } from '@/components/enlayouts/Footer'
import { Header } from '@/components/enlayouts/Header'

type LayoutProps = {
  title: string
  subTitle: string
  imgUrl: string
  enTitle?: string
  breadCrumbs: {
    name: string
    path?: string
  }[]
  children: ReactNode
  isRequiredBackground?: boolean
}

export const Layout = ({
  children,
  isRequiredBackground,
}: Pick<LayoutProps, 'children' | 'isRequiredBackground'>) => (
  <>
    <Header />
    {isRequiredBackground ? (
      <PageBackground>
        <Main>{children}</Main>
      </PageBackground>
    ) : (
      <Main>{children}</Main>
    )}

    <Footer />
  </>
)

export const TitleLayout = ({
  title,
  subTitle,
  breadCrumbs,
  children,
  isRequiredBackground,
}: Omit<LayoutProps, 'imgUrl'>) => (
  <>
    <Header />
    <Main>
      <PageTitle pageTitle={title} subPageTitle={subTitle}/>
      <Wrapper>
        <Spacer h={{ sp: 10, pc: 14 }} />
        <BreadCrumbs breadCrumbs={breadCrumbs} />
      </Wrapper>
      {isRequiredBackground ? (
        <PageBackground>{children}</PageBackground>
      ) : (
        <>{children}</>
      )}
    </Main>
    <Footer />
  </>
)

export const ImageTitleLayout = ({
  title,
  subTitle,
  enTitle,
  imgUrl,
  breadCrumbs,
  children,
  isRequiredBackground,
}: LayoutProps) => (
  <>
    <Header />
    <Main>
      <TopPageTitle titleText={title} subtitleText={subTitle} enTitleText={enTitle} imgUrl={imgUrl} />
      <Spacer h={{ sp: 10, pc: 14 }} />
      <Wrapper>
        <Spacer h={{ sp: 10, pc: 14 }} />
        <BreadCrumbs breadCrumbs={breadCrumbs} />
      </Wrapper>
      {isRequiredBackground ? (
        <PageBackground>{children}</PageBackground>
      ) : (
        <>{children}</>
      )}
    </Main>
    <Footer />
  </>
)

const Wrapper = styled.div`
  @media screen and (max-width: 1047px) {
    display: none;
  }
`

const Main = styled.main`
  padding-top: 105px;

  @media screen and (max-width: 1047px) {
    padding-top: 53px;
  }
`
